<template>
    <el-dialog class="common-dialog noHeader check-detail-dialog"
               :title="itemData.title"
               :visible="visible"
               :before-close="closeDialog">
        <div v-if="itemData.data" v-show="isActiveContent(1, false)">
            <el-row :gutter="20">
                <el-col :span="17">
                    <p class="title">{{itemData.desc}}</p>
                </el-col>
                <el-col :span="4">
                    <p>
                        <i v-if="!itemData.data.length" class="el-icon-loading"></i>
                        <a v-else href="javascript:void(0);" @click="setActiveContent(2)">{{getResultCount(itemData)}}条记录</a>
                    </p>
                </el-col>
                <el-col :span="3">
                    <p :class="[itemData.result ? 'success' : 'error']">{{getResultHint(itemData)}}</p>
                </el-col>
            </el-row>
            <div class="suggest">
                <div class="suggest-title">
                    <i class="xw-icon xw-icon-notice"></i>
                    <p class="lineBlock">优化建议</p>
                </div>
                <p class="suggest-content">{{itemData.suggest}}</p>
            </div>
        </div>

        <!--底部营销专家-->
        <div slot="footer" class="expert clearfix">
            <div class="expert-item fl">
                <img class="expert-icon" src="../../content/images/check/detail-expert-icon.png" alt="">
                <img class="fl" src="../../content/images/check/detail-expert1.png" alt="牛商网营销专家">
                <div class="fl">
                    <p class="expert-t1">牛商网营销专家</p>
                    <p class="expert-t2">一对一精准人工诊断</p>
                    <span class="expert-t3">每天限<span class="error">10名免费</span></span>
                    <el-button v-bd-track-event="['营销力诊断', '点击诊断项里面的咨询按钮（李）']" type="primary" class="expert-btn" @click="openCustomer()">咨询</el-button>
                </div>
            </div>
            <div class="expert-item fr">
                <img class="expert-icon" src="../../content/images/check/detail-expert-icon.png" alt="">
                <img class="fl" src="../../content/images/check/detail-expert2.png" alt="牛商网营销专家">
                <div class="fl">
                    <p class="expert-t1">牛商网营销专家</p>
                    <p class="expert-t2">一对一精准人工诊断</p>
                    <span class="expert-t3">每天限<span class="error">10名免费</span></span>
                    <el-button v-bd-track-event="['营销力诊断', '点击诊断项里面的咨询按钮（朱）']" type="primary" class="expert-btn" @click="openCustomer()">咨询</el-button>
                </div>
            </div>
        </div>

        <div class="back-detail" v-show="isActiveContent(1, true)" @click="setActiveContent(1)">
            <i class="xw-icon xw-icon-goback"></i>
            <p class="lineBlock">返回详情</p>
        </div>
        <!--详情网址列表-->
        <el-table class="detail-table" :data="itemData.data" height="310" v-show="isActiveContent(2)" style="width: 100%">
            <el-table-column prop="url" label="网页" width="500">
                <template slot-scope="props">
                    <a :href="props.row.url" target="_blank">{{props.row.url}}</a>
                </template>
            </el-table-column>
            <el-table-column
                    label="检测结果"
                    prop="result"
                    width="150"
                    :filters="[{ text: 'YES', value: true }, { text: 'NO', value: false }]"
                    :filter-method="filterTag"
                    filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag size="medium" :type="scope.row.result ? 'success' : 'danger'">{{scope.row.result ? 'YES' : 'NO'}}</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <!--查看示例-->
        <el-button type="text" class="example-btn" v-show="isActiveContent(1)" @click="setActiveContent(3)">查看示例</el-button>
        <div class="example-content" v-show="isActiveContent(3)">
            <img :src="itemData.exampleImg">
        </div>

        <!--加分项标识-->
        <div class="item-type-2" v-if="itemData.type === 2">此项不影响得分</div>

    </el-dialog>
</template>

<script>
    import { mapActions } from 'vuex'
    import _ from 'lodash'
    export default {
        props: ['visible', 'itemId'],
        data () {
            return {
                itemData: {},
                activeContent: 1,
                //网址详情表格
                toggleContent: true,
                // 牛商网营销专家客服
                expertLink: 'http://p.qiao.baidu.com/cps/chat?siteId=12162004&userId=1052055'
            }
        },
        watch: {
            visible(newVal) {
                if (!newVal) return;
                this.itemData = {};
                this.getItemData(this.itemId).then(data => {
                    let dataDetail = data.data;
                    data.data = [];
                    this.itemData = data;
                    this.dialogVisible = true;

                    setTimeout(() => {
                        this.itemData.data = dataDetail;
                    }, 300)
                }, () => {
                    this.$message.error('获取信息失败');
                });
            }
        },
        methods: {
            ...mapActions('check', ['getItemData']),
            //关闭详情窗口
            closeDialog () {
                this.setActiveContent(1);
                this.$emit('closeDialog');
            },
            //获取检测结果的正确或错误的相应提示语
            getResultHint (item) {
                return item.result ? item.resultHint[0] : item.resultHint[1];
            },
            //url列表筛选
            filterTag(value, row) {
                return row.result === value;
            },
            //获取检测结果正确或错误的数量
            getResultCount(item) {
                return _.filter(item.data, {result: item.result}).length;
            },
            isActiveContent(type, isReverse) {
                return isReverse ? this.activeContent !== type : this.activeContent === type;
            },
            setActiveContent(type) {
                this.activeContent = type;
            },
            //切换详情和url列表界面
            switchContent (status) {
                this.toggleContent = status === undefined ? !this.toggleContent : status;
            },
            // 牛商网营销专家客服
            openCustomer () {
                let url = 'http://p.qiao.baidu.com/cps/chat?siteId=12162004&userId=1052055';
                window.open(url, '', 'width=800,height=600,left=200,top=100');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-table a {
        color: #333;
    }
    .title {
        height: 70px;
        color: #949494;
    }
    /*优化建议*/
    .suggest {
        .suggest-title {
            position: relative;
            font-size: 18px;
            color: #fff;
            border-bottom: 1px solid #ccc;
            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 50%;
                height: 100%;
                background: #2472e8;
                border-radius: 3px 3px 0 0;
            }
            i, p {
                position: relative;
                vertical-align: middle;
            }
            i {
                margin: 0 10px 0 25px;
            }
            p {
                margin: 0;
            }
        }
        .suggest-content {
            font-size: 16px;
            margin: 26px 0;
            line-height: 26px;
            max-height: 160px;
            overflow: hidden;
        }
    }
    /*url详情*/
    .back-detail {
        position: absolute;
        top: 70px;
        right: 100px;
        cursor: pointer;
        i, p {
            vertical-align: middle;
            margin: 0;
        }
    }
    .el-tag {
        width: 80px;
        height: 25px;
        color: #fff;
        text-align: center;
    }
    /*示例*/
    .example-btn {
        position: absolute;
        top: 65px;
        right: 100px;
    }
    .example-content {
        text-align: center;
        img {
            max-width: 100%;
            max-height: 310px;
        }
    }
    /*加分项标识*/
    .item-type-2 {
        position: absolute;
        top: 0;
        right: 20px;
        width: 26px;
        height: 130px;
        font-size: 14px;
        color: #fff;
        line-height: 15px;
        text-align: center;
        padding-top: 2px;
        background: url("../../content/images/item-type-2.png") no-repeat;
    }
    /*关闭*/
    .el-icon-close {
        position: absolute;
        top: 20px;
        right: -42px;
        color: #fff;
        cursor: pointer;
    }

    .expert {
        text-align: left;
        .expert-item {
            position: relative;
        }
        .expert-icon {
            position: absolute;
            top: -3px;
            left: -3px;
        }
        img {
            margin-right: 15px;
        }
        .expert-t1, .expert-t2 {
            margin: 0;
        }
        .expert-t1 {
            font-size: 16px;
        }
        .expert-t2 {
            font-size: 14px;
            color: #808083;
            margin: 5px 0 10px 0;
        }
        .expert-btn {
            font-size: 13px;
            padding: 5px 13px;
            margin-left: 8px;
        }
    }
</style>
<style lang="scss">
    .check-detail-dialog {
        .el-dialog {
            height: 560px;
        }
        .el-dialog__footer {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 1.25rem 4rem;
            border-top: 1px solid #ccc;
        }
        $successColor: #42b86b;
        $dangerColor: #e1a900;
        .el-tag--success {
            background-color: $successColor;
            border-color: $successColor;
        }
        .el-tag--danger {
            background-color: $dangerColor;
            border-color: $dangerColor;
        }
        .detail-table .el-table__body-wrapper {
            height: 251px;
            overflow-y: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/DetailDialog.vue